<template>

    <div>
        <Request
                ref="requestEmbeddedPurchase"
                root="/shop/embedded"
                method="GET"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">
                <b-nav class="mb-4" fill>
                    <b-nav-item :active="dataStep === 'product'" :disabled="dataStep !== 'product'">{{Core.Definition.getDefinition('Sélection de produit')}}</b-nav-item>
                    <b-nav-item :active="dataStep === 'invoice'" :disabled="dataStep !== 'invoice'">{{Core.Definition.getDefinition('Facturation')}}</b-nav-item>
                    <b-nav-item v-show="dataHasOptions" :active="dataStep === 'options'" :disabled="dataStep !== 'options'">{{Core.Definition.getDefinition('Options')}}</b-nav-item>
                    <b-nav-item :active="dataStep === 'checkout'" :disabled="dataStep !== 'checkout'">{{Core.Definition.getDefinition('Confirmation')}}</b-nav-item>
                </b-nav>

                <div v-show="dataStep === 'product'">

                    <b-row v-if="dataProduct===null||dataProduct.value !== undefined" class="mb-3">
                        <b-col>
                            <InputSelect
                                    ref="selectProduct"
                                    :options="dataProductOptions"
                                    v-model="dataProduct"
                                    @onSelect="onSelectProduct"
                                    :label="Core.Definition.getDefinition('Choisissez un produit')"></InputSelect>
                        </b-col>
                    </b-row>

                    <div v-if="dataProduct !== null">
                        <b-row v-if="!Core.Validation.isEmpty(dataProduct.data.shortDescription)" class="mb-3">
                            <b-col>
                                <div v-html="dataProduct.data.shortDescription"></div>
                            </b-col>
                        </b-row>

                        <b-row v-if="dataProduct.data.type === Core.Product.typeRecurringSubscription">
                            <b-col>
                                <strong class="mt-4">
                                    {{Core.Definition.getDefinition('Durée de l\'abonnement')}}
                                </strong>
                                <p>
                                    {{Core.Text.format(Core.Definition.getDefinition('Du {0} au {1}.'),
                                    Core.Date.getToday('DD MMM YYYY'), Core.Date.calc(dataProduct.data.periodPayment, dataProduct.data.periodPaymentLength, 'DD MMM YYYY'))}}
                                </p>
                            </b-col>
                            <b-col>
                                <strong class="mt-4">
                                    {{Core.Definition.getDefinition('Paiements')}}
                                </strong>
                                <p>
                                    {{Core.Text.format(Core.Definition.getDefinition('{0} {1} {2} pendant {3} {4}.'),
                                    Core.Currency.format(Core.Commerce.total(dataProduct.data.regularPrice, Core.Session.Setting.getTaxes())),
                                    Core.Select.label(dataProduct.data.periodPaymentInterval, Core.Product.periodIntervalOptions()).toLowerCase(),
                                    Core.Select.label(dataProduct.data.periodPayment, Core.Product.periodOptions()).toLowerCase(),
                                    dataProduct.data.periodPaymentLength,
                                    Core.Select.label(dataProduct.data.periodPayment, Core.Product.periodOptions()).toLowerCase())}}
                                </p>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col v-if="dataProduct.data.type !== Core.Product.typeRecurringSubscription">
                                <strong class="mt-4">
                                    {{Core.Definition.getDefinition('Paiements')}}
                                </strong>
                                <p v-if="dataProduct.data.isTaxable==1">

                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                        {{Core.Text.format(Core.Definition.getDefinition('{0} à payer dès maintenant.'),
                                        Core.Currency.format(Core.Commerce.total(dataProduct.data.regularPrice, Core.Session.Setting.getTaxes())))}}
                                    </span>
                                    <span v-if="dataProduct.quantity>0">
                                        {{Core.Text.format(Core.Definition.getDefinition('{0} à payer dès maintenant.'),
                                         Core.Currency.format(Core.Commerce.total(dataProduct.data.regularPrice * dataProduct.quantity, Core.Session.Setting.getTaxes())))}}
                                    </span>

                                </p>
                                <p v-if="dataProduct.data.isTaxable==0">

                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                        {{Core.Text.format(Core.Definition.getDefinition('{0} à payer dès maintenant.'),
                                          Core.Currency.format(dataProduct.data.regularPrice))}}
                                    </span>
                                    <span v-if="dataProduct.quantity>0">
                                        {{Core.Text.format(Core.Definition.getDefinition('{0} à payer dès maintenant.'),
                                        Core.Currency.format(dataProduct.data.regularPrice * dataProduct.quantity))}}
                                    </span>

                                </p>
                            </b-col>
                            <b-col v-if="dataProduct.data.bookingLimit > 0">
                                <strong class="mt-4">
                                    {{Core.Definition.getDefinition('Limitations')}}
                                </strong>
                                <p>
                                    {{Core.Text.format(Core.Definition.getDefinition('Vous pouvez réserver jusqu\'à {0} fois {1} {2}.'), dataProduct.data.bookingLimit, Core.Select.label(dataProduct.data.bookingLimitInterval, Core.Product.periodIntervalOptions()).toLowerCase(),
                                    Core.Select.label(dataProduct.data.bookingLimitPeriod, Core.Product.periodOptions()).toLowerCase())}}
                                </p>
                            </b-col>
                        </b-row>
                    </div>

                </div>

                <div v-if="dataStep === 'options'">
                    <ProductOption ref="productOption" :selectOptions="dataSelectOptions" :formTemplates="dataFormTemplates" v-model="dataProduct.data"></ProductOption>
                    <b-row>
                        <b-col>
                            <b-alert :show="dataProductOptionAlertMessage !== false" variant="danger">
                                {{dataProductOptionAlertMessage}}
                            </b-alert>
                        </b-col>
                    </b-row>
                </div>

                <div v-show="dataStep === 'invoice'">
                    <CForm
                            ref="formInvoice"
                            :structure="dataFormStructure.invoice">
                    </CForm>
                </div>

                <div v-if="dataStep === 'checkout'">

                    <div v-if="dataProduct !== null && dataProduct !== false && dataProduct.data.type !== Core.Product.typeRecurringSubscription">
                        <div class="mb-3" ><strong>{{Core.Definition.getDefinition('Sommaire')}}</strong></div>
                        <table class="table">
                            <tbody>
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition('Sous-total')}}
                                </td>
                                <td>
                                    <span v-if="dataProduct.quantity>0">
                                         {{Core.Currency.format(dataProduct.data.regularPrice * dataProduct.quantity)}}
                                    </span>
                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                         {{Core.Currency.format(dataProduct.data.regularPrice)}}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="dataProduct.data.isTaxable==1" v-for="tax in dataTaxes">
                                <td>
                                    {{tax.label}}
                                </td>
                                <td>
                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                        {{Core.Currency.format(Core.Taxes.total(dataProduct.data.regularPrice,tax))}}
                                    </span>
                                    <span v-if="dataProduct.quantity>0">
                                        {{Core.Currency.format(Core.Taxes.total(dataProduct.data.regularPrice * dataProduct.quantity,tax))}}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="dataProduct.data.isTaxable==1">
                                <td>
                                    {{Core.Definition.getDefinition('Total')}}
                                </td>
                                <td>
                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                        {{Core.Currency.format(Core.Commerce.total(dataProduct.data.regularPrice, Core.Session.Setting.getTaxes()))}}
                                    </span>
                                    <span v-if="dataProduct.quantity>0">
                                        {{Core.Currency.format(Core.Commerce.total(dataProduct.data.regularPrice * dataProduct.quantity, Core.Session.Setting.getTaxes()))}}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="dataProduct.data.isTaxable==0">
                                <td>
                                    {{Core.Definition.getDefinition('Total')}}
                                </td>
                                <td>

                                    <span v-if="dataProduct.quantity<=0||dataProduct.quantity=='0'||dataProduct.quantity==undefined||dataProduct.quantity==''">
                                        {{Core.Currency.format(dataProduct.data.regularPrice)}}
                                    </span>
                                    <span v-if="dataProduct.quantity>0">
                                        {{Core.Currency.format(dataProduct.data.regularPrice * dataProduct.quantity)}}
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="dataProduct !== null && dataProduct !== false && dataProduct.data.type !== '' && dataProduct.data.type === Core.Product.typeRecurringSubscription">
                        <div class="mb-3"><strong>{{Core.Definition.getDefinition('Calendrier des paiements')}}</strong></div>
                        <table class="table">
                            <tbody>
                                <tr v-for="payment in Mantle.Subscription.evalPayments(dataProduct.data.regularPrice, dataProduct.data.isTaxable, dataProduct.data.periodPaymentLength, dataProduct.data.periodPayment, dataProduct.data.periodPaymentInterval,  'CC', 'waiting', 'DD MMM YYYY')">
                                    <td>
                                        {{payment.date}}
                                    </td>
                                    <td>
                                        {{Core.Currency.format(payment.total)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <strong>{{Core.Definition.getDefinition('Moyen de paiement')}}</strong>
                    <hr/>

                    <b-row class="mb-4" v-if="dataPaymentMethods.length > 1">
                        <b-col>
                            <b-form-group
                                    class="c-text"
                                    :label="Core.Definition.getDefinition('Veuillez choisir un mode de paiement')">
                                <b-select v-model="dataPaymentMethod">
                                    <option :value="paymentMethod.value" v-for="paymentMethod in dataPaymentMethods">
                                        {{paymentMethod.label}}
                                    </option>
                                </b-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4" v-if="dataPaymentMethod === Core.Payment.methodCC">
                        <b-col>
                            <InputCC
                                    :onTokenizationSuccess="onTokenizationSuccess"
                                    v-model="dataCC"
                                    ref="cc">
                            </InputCC>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4" v-if="dataPaymentMethod === Core.Payment.methodPayLater">
                        <b-col>
                            <b-alert variant="success" show>
                                {{Core.Definition.getDefinition('Vous devrez payer la totalité en arrivant sur les lieux.')}}
                            </b-alert>
                        </b-col>
                    </b-row>

                    <div v-if="dataTermsRefundPolicy !== ''">
                        <strong>{{Core.Definition.getDefinition("Termes et conditions")}}</strong>
                        <p class="terms" v-html="dataTermsRefundPolicy"></p>
                        <InputCheckbox
                                :label="Core.Definition.getDefinition('J\'ai lu et j\'accepte les termes et conditions')"
                                v-model="dataAcceptTerm"></InputCheckbox>
                    </div>
                    <b-alert variant="danger" show v-if="dataAcceptTermAlert">
                        {{Core.Definition.getDefinition('Vous devez accepter les termes et les conditions.')}}
                    </b-alert>
                </div>

                <hr/>
                <div class="text-right">
                    <b-button-group>
                        <b-button @click="onPrevClick" :disabled="dataStep === 'product'" variant="light" class="btn"><i class="fa fa-chevron-left"></i> {{Core.Definition.getDefinition('Précédent')}}</b-button>
                        <b-button :disabled="dataDisabled" @click="onNextClick" variant="primary" class="btn">{{Core.Definition.getDefinition('Suivant')}} <i class="fa fa-chevron-right"></i></b-button>
                    </b-button-group>
                </div>
                <b-alert class="mt-3" :show="dataError !== ''" variant="danger">
                    {{dataError}}
                </b-alert>
            </slot>
        </Request>
    </div>

</template>

<script>
    import DynamicForm from './DynamicForm'
    import InputSelect from './InputSelect'
    import InputText from './InputText'
    import InputPhone from './InputPhone'
    import InputCountry from './InputCountry'
    import InputProvince from './InputProvince'
    import InputCheckbox from './InputCheckbox'
    import InputCC from './InputCC'
    import Request from './Request'
    import CForm from './CForm'
    import ProductOption from './ProductOption'
    import PluginRequest from './PluginRequest'
    export default {
        name: 'EmbeddedPurchase',
        components: {
            InputProvince,
            InputCountry,
            InputText,
            InputSelect,
            DynamicForm,
            InputCC,
            InputPhone,
            Request,
            CForm,
            ProductOption,
            InputCheckbox,
            PluginRequest
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            product: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            eventDateId: {
                type: String | Number,
                default: ''
            }
        },
        computed: {
        },
        watch: {
        },
        mounted() {
            if(Core.Validation.isId(this.product.id)) {
                this.dataProduct = this.product
            }

            let publicPaymentMethods = Core.Session.Setting.getSetting('commerce.general.paymentMethodPublic')
            if (!Core.Validation.isEmpty(publicPaymentMethods)) {

                if (!Array.isArray(publicPaymentMethods)) {
                    publicPaymentMethods = publicPaymentMethods.split(',')
                }

                let firstPublicPaymentMethod = ''
                for(let publicPaymentMethod in publicPaymentMethods) {
                    publicPaymentMethod = publicPaymentMethods[publicPaymentMethod]
                    firstPublicPaymentMethod = publicPaymentMethod
                    this.dataPaymentMethods.push(
                        {
                            value: publicPaymentMethod,
                            label: Core.Payment.methodLabel(publicPaymentMethod)
                        }
                    )
                }

                if (this.dataPaymentMethods.length === 1) {
                    this.dataPaymentMethod = firstPublicPaymentMethod
                }
            }

            this.dataTaxes = Core.Session.Setting.getTaxes()
            this.$refs.requestEmbeddedPurchase.clearArgs()
            this.$refs.requestEmbeddedPurchase.setMethod('GET')
            this.$refs.requestEmbeddedPurchase.addArg('search', this.searchArgs, Core.Value.typeJSON)
            this.$refs.requestEmbeddedPurchase.request()
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataProductOptionAlertMessage: false,
                dataEventDateId: '',
                dataStep: 'product',
                dataTaxes: [],
                dataProductOptions: [],
                dataForms: [],
                dataProduct: null,
                dataError: '',
                dataCC: {
                    holderName: '',
                    number: '',
                    expMonth: '',
                    expYear: '',
                    CVD: '',
                    token: ''
                },
                dataDisabled: false,
                dataFormTemplates: [],
                dataHasOptions: false,
                dataAcceptTerm: false,
                dataAcceptTermAlert: false,
                dataTermsRefundPolicy: '',
                dataSelectOptions: {
                    conditionalSeasonId: [],
                    conditionalLeagueId: [],
                    conditionalDistrictId: [],
                    teamId: [],
                    participantCategoryId: [],
                    tshirtSize: []
                },
                dataPaymentMethods: [],
                dataPaymentMethod: 'CC',
                dataFormStructure: {
                    invoice: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'firstname'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'lastname'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'email'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'phone'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'mobile'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'billingAddress'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'billingCity'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'billingZipcode'
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        fields: [
                            {
                                id: 'firstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'lastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'email',
                                type: 'email',
                                required: true,
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'phone',
                                type: 'phone',
                                required: true,
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'mobile',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Mobile'),
                                value: ''
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Adresse'),
                                value: ''
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Ville'),
                                value: ''
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Code postal'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            validateOptions() {
                this.dataProductOptionAlertMessage = false
                if (this.dataProduct !== null) {
                    let result = Mantle.ProductOption.validation(this.dataProduct.data, 0)
                    if (result.isValid === false) {
                        this.dataProductOptionAlertMessage = result.alert
                        return false
                    }

                    this.dataForms = []
                    if(this.dataFormTemplates.length > 0) {
                        for(let formTemplate in this.dataFormTemplates) {
                            formTemplate = this.dataFormTemplates[formTemplate]
                            if (this.$refs['productOption'].$refs['integratedForm' + formTemplate.formTemplateId]!==undefined && this.$refs['productOption'].$refs['integratedForm' + formTemplate.formTemplateId][0]!==undefined) {
                                if (!this.$refs['productOption'].$refs['integratedForm' + formTemplate.formTemplateId][0].validate()) {
                                    this.dataProductOptionAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez compléter les champs requis du formulaire'))
                                    return false
                                } else {
                                    this.dataForms.push({
                                        formTemplateId: formTemplate.formTemplateId,
                                        productType: formTemplate.productType,
                                        productId: formTemplate.productId,
                                        values: this.$refs['productOption'].$refs['integratedForm' + formTemplate.formTemplateId][0].getValues()
                                    })
                                }
                            }
                        }
                    }
                }
                return true
            },
            onSelectProduct(val) {
                if (val !== null && val.data !== null && val.data !== undefined && (Core.Validation.isId(val.data.formTemplateId)||Core.Product.conditionalIsEnabled(val.data)||Core.Product.participantModeIsEnabled(val.data))) {
                    this.dataProduct.data = Mantle.ProductOption.prepare(val.data)
                    this.dataHasOptions = true
                } else {
                    this.dataHasOptions = false
                }
            },
            onNextClick() {
                this.dataError = ''
                switch (this.dataStep) {
                    case 'product':
                        if (this.dataProduct !== null && Core.Validation.isId(this.dataProduct.data.id)) {
                            this.dataStep = 'invoice'
                        } else {
                            this.dataError = Core.Definition.getDefinition('Vous devez choisir un produit.')
                        }
                        break
                    case 'invoice':
                        if (this.$refs.formInvoice.validate()) {
                            if (this.dataHasOptions) {
                                this.dataStep = 'options'
                            } else {
                                this.dataStep = 'checkout'
                            }
                        }
                        break
                    case 'options':
                        if (this.validateOptions()) {
                            this.dataStep = 'checkout'
                        }
                        break
                    case 'checkout':
                        this.dataAcceptTermAlert = false
                        if (this.dataTermsRefundPolicy === '' || this.dataAcceptTerm === true) {
                            switch(this.dataPaymentMethod) {
                                case Core.Payment.methodCC:
                                    if (this.dataPaymentMethod === Core.Payment.methodCC) {
                                        if (this.dataCC.number !== ''
                                            && this.dataCC.holderName !== ''
                                            && this.dataCC.CVD !== ''
                                            && this.dataCC.expYear !== ''
                                            && this.dataCC.expMonth !== '') {
                                            this.$refs.cc.getToken()
                                            this.dataDisabled = true
                                        }
                                    }
                                    break
                                case Core.Payment.methodPayLater:
                                    this.dataDisabled = true
                                    this.onTokenizationSuccess(Core.Payment.methodPayLater)
                                    break
                            }

                        } else {
                            this.dataAcceptTermAlert = true
                        }
                        break
                }
            },
            onPrevClick() {
                this.dataError = ''
                switch(this.dataStep) {
                    case 'product':
                        break
                    case 'invoice':
                        this.dataStep = 'product'
                        break
                    case 'options':
                        this.dataStep = 'invoice'
                        break
                    case 'checkout':
                        if (this.dataHasOptions) {
                            this.dataStep = 'options'
                        } else {
                            this.dataStep = 'invoice'
                        }
                        break
                }
            },
            onRequestSuccess(data) {

                this.dataDisabled = false
                if (data.productOptions !== undefined) {
                    this.dataProductOptions = data.productOptions
                }

                if (data.selectOptions !== undefined) {
                    this.dataSelectOptions = data.selectOptions
                }

                if (data.formTemplates !== undefined) {
                    this.dataFormTemplates = data.formTemplates
                }

                if (data.invoice !== undefined) {
                    for(let key in data.invoice) {
                        let value = data.invoice[key]
                        let field = Core.Array.findByKey(this.dataFormStructure.invoice.fields, 'id', key)
                        if (field.type !== undefined) {
                            let selectOptions = []
                            if (data.selectOptions !== undefined) {
                                if (data.selectOptions[key] !== undefined) {
                                    selectOptions = data.selectOptions[key]
                                }
                            }
                            value = Core.Value.encode(value, field.type, selectOptions)
                            this.$refs.formInvoice.setValue(key, value)
                        }
                    }
                }

                let eventDateId = false
                if (data.eventDateId !== undefined&&Core.Validation.isId(data.eventDateId)) {
                    eventDateId = data.eventDateId
                }

                if (data.referenceNumber !== undefined||data.eventDateId !== undefined) {
                    this.$emit('onSuccess', data.purchases, data.referenceNumber, eventDateId)
                }

                if (data.termsRefundPolicy) {
                    this.dataTermsRefundPolicy = data.termsRefundPolicy
                }

            },
            onTokenizationSuccess(token) {
                let payment = {
                    token: token
                }

                let formInvoiceValues = this.$refs.formInvoice.getValues()

                let products = []
                if (this.dataProduct !== null) {
                    let participant = false
                    if (this.dataProduct.data.participant !== undefined) {
                        participant = Core.Value.decode(this.dataProduct.data.participant, Core.Value.typeParticipant)
                    }
                    let conditional = false
                    if (this.dataProduct.data.conditional !== undefined) {
                        conditional = Core.Value.decode(this.dataProduct.data.conditional, Core.Value.typeConditional)
                    }

                    let participants = []
                    for(let participant in this.dataProduct.participants) {
                        participant = this.dataProduct.participants[participant]
                        participant = Core.Value.decode(participant, Core.Value.typeParticipant)
                        participants.push(participant)
                    }

                    let quantity = 1
                    if (this.dataProduct.quantity !== undefined) {
                        quantity = this.dataProduct.quantity
                    }

                    products = [{
                        id: this.dataProduct.data.id,
                        quantity: quantity,
                        cartOptions: [{
                            id: this.dataProduct.data.id,
                            participant: participant,
                            participants: participants,
                            conditional: conditional
                        }]
                    }]
                }

                this.$refs.requestEmbeddedPurchase.clearArgs()
                this.$refs.requestEmbeddedPurchase.setMethod('POST')
                this.$refs.requestEmbeddedPurchase.addArg('paymentMethod', this.dataPaymentMethod)
                this.$refs.requestEmbeddedPurchase.addArg('eventDateId', this.eventDateId)
                this.$refs.requestEmbeddedPurchase.addArg('products', JSON.stringify(products))
                this.$refs.requestEmbeddedPurchase.addArg('forms', JSON.stringify(this.dataForms))
                this.$refs.requestEmbeddedPurchase.addArg('payment', JSON.stringify(payment))
                this.$refs.requestEmbeddedPurchase.addArg('firstname', formInvoiceValues['firstname'])
                this.$refs.requestEmbeddedPurchase.addArg('lastname', formInvoiceValues['lastname'])
                this.$refs.requestEmbeddedPurchase.addArg('email', formInvoiceValues['email'])
                this.$refs.requestEmbeddedPurchase.addArg('billingAddress', formInvoiceValues['billingAddress'])
                this.$refs.requestEmbeddedPurchase.addArg('billingCity', formInvoiceValues['billingCity'])
                this.$refs.requestEmbeddedPurchase.addArg('billingZipcode', formInvoiceValues['billingZipcode'])
                this.$refs.requestEmbeddedPurchase.request()
            }
        }
    }
</script>
